import { render, staticRenderFns } from "./scene11.vue?vue&type=template&id=09f749bb&scoped=true&"
import script from "./scene11.vue?vue&type=script&lang=ts&"
export * from "./scene11.vue?vue&type=script&lang=ts&"
import style0 from "./scene11.vue?vue&type=style&index=0&id=09f749bb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f749bb",
  null
  
)

export default component.exports